module.exports = __webpack_public_path__ + "static/media/linkedin-icon.cf2dd74e.png";